module.exports = __webpack_public_path__ + "static/media/Geliefert.f540d339.svg";